import { render, staticRenderFns } from "./addProgram.vue?vue&type=template&id=1b6eceba&scoped=true"
import script from "./addProgram.vue?vue&type=script&lang=js"
export * from "./addProgram.vue?vue&type=script&lang=js"
import style0 from "./addProgram.vue?vue&type=style&index=0&id=1b6eceba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6eceba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6eceba')) {
      api.createRecord('1b6eceba', component.options)
    } else {
      api.reload('1b6eceba', component.options)
    }
    module.hot.accept("./addProgram.vue?vue&type=template&id=1b6eceba&scoped=true", function () {
      api.rerender('1b6eceba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programList/components/addProgram.vue"
export default component.exports